import { SyntheticEvent } from 'react';
import { StyledLogLevel } from './LogViewer.styles.tsx';
import { LOG_LEVEL_TOKEN_SPLITTER, LOG_LEVEL_TOKENS } from './logLevels.ts';

const stopPropagation = (e: SyntheticEvent) => e.stopPropagation();

export const renderLog = (log: string) => {
  const parts = log.split(LOG_LEVEL_TOKEN_SPLITTER);

  const renderedLog = [];

  for (let i = 0; i < parts.length; i += 2) {
    if (parts[i]) {
      renderedLog.push(<span key={i}>{parts[i]}</span>);
    }

    const token = parts[i + 1];
    const level = token ? LOG_LEVEL_TOKENS[token] : undefined;

    if (token && level) {
      renderedLog.push(
        <StyledLogLevel key={i + 1} level={level}>
          {token}
        </StyledLogLevel>,
      );
    }
  }

  return <span onContextMenu={stopPropagation}>{renderedLog}</span>;
};
